export const RATING_CATEGORIES = [
  { key: "overall_rating", label: "Rating Keseluruhan" },
  { key: "cleanliness_rating", label: "Kebersihan" },
  { key: "location_rating", label: "Lokasi" },
  { key: "facility_rating", label: "Fasilitas" },
  { key: "owner_rating", label: "Owner" },
];

export const BREAKDOWN_ROWS = [
  { key: "overall", label: "Keseluruhan" },
  { key: "cleanliness", label: "Kebersihan" },
  { key: "location", label: "Lokasi" },
  { key: "facility", label: "Fasilitas" },
  { key: "owner", label: "Owner" },
];

export const REVIEW_STATUS_LABELS = {
  published: "Ditampilkan",
  hidden: "Disembunyikan",
  rejected: "Ditolak",
};

export const REVIEW_STATUS_STYLES = {
  published: "bg-emerald-100 text-emerald-700 border-emerald-200",
  hidden: "bg-amber-100 text-amber-700 border-amber-200",
  rejected: "bg-rose-100 text-rose-700 border-rose-200",
};

export function formatReviewDate(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });
}
